import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button } from "@astryxdesign/core/Button";
import * as stylex from "@stylexjs/stylex";
import { accessAPI, queries } from "../lib/api";
import { styles } from "../lib/styles";
export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: Shell
});
function Shell() {
  const me = useQuery(queries.me());
  const logout = useMutation({
    mutationFn: accessAPI.logout,
    onSuccess: () => {
      window.location.assign("/");
    }
  });
  if (me.isPending) return <main {...stylex.props(styles.main)} aria-busy="true">
        Checking your session…
      </main>;
  if (!me.data) return <div {...stylex.props(styles.shell)}>
        <main {...stylex.props(styles.login)}>
          <section {...stylex.props(styles.panel)}>
            <h1 {...stylex.props(styles.title)}>
              Your servers.
              <br />
              Your identity.
            </h1>
            <p {...stylex.props(styles.description)}>
              Sign in with your company account to manage short-lived SSH access. Your private key
              stays on your device.
            </p>
            <div {...stylex.props(styles.actions)}>
              <a href="/auth/login">Sign in with SSB SSO</a>
            </div>
          </section>
        </main>
      </div>;
  return <div {...stylex.props(styles.shell)}>
      <header {...stylex.props(styles.header)}>
        <Link to="/" {...stylex.props(styles.brand)}>
          SSBI Access
        </Link>
        <nav aria-label="Main navigation" {...stylex.props(styles.nav)}>
          {me.data.admin && <>
              <Link to="/" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Servers
              </Link>
              <Link to="/rules" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Access rules
              </Link>
              <Link to="/audit" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
                Activity
              </Link>
            </>}
          <Link to="/connect" {...stylex.props(styles.navLink)} activeProps={stylex.props(styles.active)}>
            Connect
          </Link>
        </nav>
        <div {...stylex.props(styles.nav)}>
          <span {...stylex.props(styles.identity)}>{me.data.email}</span>
          <Button label="Sign out" xstyle={styles.headerButton} size="sm" onClick={() => logout.mutate()} isLoading={logout.isPending} />
        </div>
      </header>
      <main {...stylex.props(styles.main)}>
        <Outlet />
      </main>
    </div>;
}